module.exports = [{
      plugin: require('C:/Users/Ricky/Documents/GitHub/TheRamik.github.io/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":750,"linkImagesToOriginal":false},
    },{
      plugin: require('C:/Users/Ricky/Documents/GitHub/TheRamik.github.io/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
